export default __webpack_public_path__ + "static/media/hardedit_containers.795a2766.jpg";